const Colors = {

    lightBlue: '#46FFFF',
    selectedRed: '#FC688A',
    unselectedGrey: '#F1F0EE',

};

export default Colors